/* eslint-disable */
import ReactDOM from "react-dom";
import { get } from 'lodash';
import {
  ELEMENT_DICTIONARY,
  OPTION_DICTIONARY_V3,
  stripQuotes,
} from "src/pages/facesheet/_id/eligibility/surveyjsTemplates/createElAssessTemplate"
import { hash } from "immutable";

export const getEligibleServiceUtilV4 = (screening, identifiedNeeds) => {
  try {
    if (!screening) { return null; }

    const eligibleServices = [];

    const screen = screening.data.screen;
    const qVerifyMedicaidEnrollment = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qVerifyMedicaidEnrollment
    );
    const qVerifyIdentity = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qVerifyIdentity
    );
    const qConfirmAccurateInfo = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qConfirmAccurateInfo
    );
    const qNYExcludedPopulation = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qNYExcludedPopulation
    );
    const qEnhancedPopulations = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qEnhancedPopulations
    );
    const qClinicalCriteria = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qClinicalCriteria
    );
    const qDifficultyWalking = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qDifficultyWalking
    );
    const qDifficultyDressing = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qDifficultyDressing
    );

    const qRefrigerationBreastMilk = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qRefrigerationBreastMilk
    );
    const qRefrigerationMedication = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qRefrigerationMedication
    );
    const qTransportationTroubleReasons = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qTransportationTroubleReasons
    );
    const qSelectScreening = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qSelectScreening
    );

    let hasAccurateInfo = get(qConfirmAccurateInfo, 'answer.value') === "Member attests to provide accurate and complete information.";
    let hasVerifiedIdentity = get(qVerifyIdentity, 'answer.value') === "I was able to verify member's identity.";
    const VERIFIED_MEDICAID_ANSWERS = {
      // Option available before April 8
      GENERAL_VERIFIED: 'I was able to verify the member is currently enrolled in Medicaid.',
      // Options available after April 8
      MANAGED_CARE_VERIFIED: 'I was able to verify the member is currently enrolled in Medicaid Managed Care.',
      FFS_VERIFIED: 'I was able to verify the member is currently enrolled in Medicaid Fee-for-Service.',
      NOT_VERIFIED: 'I was not able to verify the member is currently enrolled in Medicaid.',
    };

    const hasVerifiedMedicaid = get(qVerifyMedicaidEnrollment, 'answer.value') === VERIFIED_MEDICAID_ANSWERS.GENERAL_VERIFIED ||
      get(qVerifyMedicaidEnrollment, 'answer.value') === VERIFIED_MEDICAID_ANSWERS.MANAGED_CARE_VERIFIED

    let isMemberInExcludedPopulation = get(qNYExcludedPopulation, 'answer.value') === 'Yes';
    let hasValidScreening = Boolean(get(qSelectScreening, 'answer.value'));

    const hasFoodNeed = Boolean(identifiedNeeds.includes('food'));
    const hasHousingNeed = Boolean(identifiedNeeds.includes('housing'));
    const hasUtilitiesNeed = Boolean(identifiedNeeds.includes('utilities'));
    const hasTransportationNeed = Boolean(
      identifiedNeeds.includes('transportation'),
    );

    const enhancedPopulations = get(qEnhancedPopulations, 'answers', [])
      .map((a) => stripQuotes(a.value));
    const clinicalCriteria = get(qClinicalCriteria, 'answers', [])
      .map((a) => stripQuotes(a.value));
    const qHousingSafetyConcerns = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qHousingSafetyConcerns,
    );

    const hasDifficultyWalking = get(qDifficultyWalking, 'answer.value') === 'Yes';
    const hasDifficultyDressing = get(qDifficultyDressing, 'answer.value') === 'Yes';
    const requireRefrigerationBreastMilk = get(qRefrigerationBreastMilk, 'answer.value') === 'Yes';
    const requireRefrigerationMedication = get(qRefrigerationMedication, 'answer.value') === 'Yes';
    const qCareRecoveryNeed = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qCareRecoveryNeed,
    );
    const hasCareRecoveryNeed = get(qCareRecoveryNeed, 'answer.value') === 'Yes';
    const qHospitalRisk = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qHospitalRisk,
    );
    const qServiceDuplicationCheck = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qServiceDuplicationCheck,
    );
    const listOfServiceDuplication = get(qServiceDuplicationCheck, 'answers', [])
      .map((a) => stripQuotes(a.value));
    const hasHospitalRisk = get(qHospitalRisk, 'answer.value') === 'Yes';
    const transportationTroubleReasons = get(qTransportationTroubleReasons, 'answers', [])
      .map((a) => stripQuotes(a.value));

    const qUtilitiesIssues = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qUtilitiesIssues,
    );
    const hasUtilitiesIssues = get(qUtilitiesIssues, 'answer.value') === 'Yes';
    // Get all snomed codes selected 
    const snomedCodesSelected = [];

    const optionIdToSnomedCodeMap = {};
    // const snomedCodesAvailable = [];  // for debugging purposes
    screen.questions.forEach((q) => {
      if (!q.options) { return; }
      q.options.forEach((o) => {
        if (o.snomed) {
          optionIdToSnomedCodeMap[o.id] = o.snomed;
          // snomedCodesAvailable.push({ // for debugging purposes
          //   question: q.primary_text,
          //   option_value: o.value,
          //   snomed: o.snomed,
          // });
        }
      });
    })

    screen.questions.forEach((q) => {
      if (!q.answer && !q.answers) { return; }
      if (q.answer) {
        const snomedCode = optionIdToSnomedCodeMap[q.answer.option_id];
        if (snomedCode) {
          snomedCodesSelected.push(snomedCode);
        }
      }
      if (q.answers) {
        q.answers.forEach((a) => {
          const snomedCode = optionIdToSnomedCodeMap[a.option_id];
          if (snomedCode) {
            snomedCodesSelected.push(snomedCode);
          }
        });
      }
    });
    const qHousingConcerns = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qHousingConcerns,
    );
    const qHousingIssues = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qHousingIssues,
    );
    const listOfHousingConcerns = get(qHousingConcerns, 'answers', [])
      .map((a) => stripQuotes(a.value));
    const listOfHousingIssues = get(qHousingIssues, 'answers', [])
      .map((a) => stripQuotes(a.value));
    const qUtilitiesIssuesTypes = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qUtilitiesIssuesTypes,
    );
    const listOfUtilitiesIssues = get(qUtilitiesIssuesTypes, 'answers', [])
      .map((a) => stripQuotes(a.value));

    const qFoodAssistanceType = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qFoodAssistanceType,
    );
    const listOfFoodAssistance = get(qFoodAssistanceType, 'answers', [])
      .map((a) => stripQuotes(a.value));
    const qCanPrepareMeals = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qCanPrepareMeals,
    );
    const cannotPrepareMeals = get(qCanPrepareMeals, 'answer.value') === 'No';

    const qCaregiverPrepareMeals = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qCaregiverPrepareMeals,
    );
    const caregiverCannotPrepareMeals = get(qCaregiverPrepareMeals, 'answer.value') === 'No';
    const caregiverCanPrepareMeals = get(qCaregiverPrepareMeals, 'answer.value') === 'Yes';

    const qTransportationAccess = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qTransportationAccess,
    );
    const hasTransportationAccess = get(qTransportationAccess, 'answer.value') === 'Yes';
    const qMedicaidPlanType = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qMedicaidPlanType,
    );
    const medicaidPlanType = get(qMedicaidPlanType, 'answer.value', '');

    // Check if the client is eligible for services
    if (
      !hasAccurateInfo ||
      !hasVerifiedIdentity ||
      !hasVerifiedMedicaid ||
      !hasValidScreening ||
      isMemberInExcludedPopulation ||
      !enhancedPopulations.length
    ) {
      return [];
    }
    const hasHousingSafetyConcerns = get(qHousingSafetyConcerns, 'answer.value') === 'Yes';
    const enhancedConditionsSetOne = enhancedPopulations.includes(OPTION_DICTIONARY_V3.medicaidHighUtilizer)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.enrolledNYS)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.pregnantAndPostpartum)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.highRiskChildUnderEighteen)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.individualsChronicReleased)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.childNutrition)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.otherPopulations);
    
    const enhancedConditionsSetTwo = enhancedPopulations.includes(OPTION_DICTIONARY_V3.medicaidHighUtilizer)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.enrolledNYS)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.highRiskChildUnderEighteen)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.individualsChronicReleased)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.childNutrition)
      || enhancedPopulations.includes(OPTION_DICTIONARY_V3.otherPopulations);

    const housingIssuesSet = listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oStayingWithFamilyOrFriends)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oStayingInShelter)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oStayingNotLiving)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oStayingNotLivingSafe)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oMightLoseHousing);

    const housingIssuesSetTwo = listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oStayingWithFamilyOrFriends)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oStayingInShelter)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oStayingNotLiving)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oStayingNotLivingSafe)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oMightLoseHousing)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oBehindOnRent)
        || listOfHousingIssues.includes(OPTION_DICTIONARY_V3.oHousingCostsTooMuch);

    const qAdditionalClinicalConditions = screen.questions.find(
      (q) => q.primary_text === ELEMENT_DICTIONARY.qAdditionalClinicalConditions,
    );
    const additionalClinicalConditions = get(qAdditionalClinicalConditions, 'answers', [])
      .map((a) => stripQuotes(a.value));

    if (
      hasHousingNeed &&
      enhancedConditionsSetOne &&
      hasHousingSafetyConcerns &&
      (
        hasDifficultyWalking ||
        hasDifficultyDressing
      ) &&
      (
      additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.qDisabilityIndependence)
      )
    ) {
      eligibleServices.push('Home Accessibility / Safety Modification (Housing)');
    }

    // Home Remediation
    if (
      hasHousingNeed &&
      enhancedConditionsSetOne &&
      hasHousingSafetyConcerns &&
      listOfHousingConcerns.includes('Mold or mildew is present.')
    ) {
      eligibleServices.push('Home Remediation Assistance: Mold and Pest (Housing)');
    }

    if (
      hasHousingNeed &&
      enhancedConditionsSetOne &&
      hasHousingSafetyConcerns &&
      listOfHousingConcerns.includes('No heating or cooling when needed.') &&
      (
        clinicalCriteria.includes(OPTION_DICTIONARY_V3.chronicCondition)
        || clinicalCriteria.includes(OPTION_DICTIONARY_V3.heatRelatedIllness)
        || clinicalCriteria.includes(OPTION_DICTIONARY_V3.coldRelatedIllness)
        || clinicalCriteria.includes(OPTION_DICTIONARY_V3.atRiskThermo)
      )
    ) {
      eligibleServices.push('Home Remediation Assistance: Ventilation Improving Systems (Housing)');
    }

    if (
      (
        hasHousingNeed &&
        (
          enhancedConditionsSetOne &&
          requireRefrigerationMedication &&
          clinicalCriteria.includes(OPTION_DICTIONARY_V3.chronicCondition) &&
          additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.qRefrigeratedMedication)
        )
      ) ||
      (
        hasHousingNeed &&
        (
          enhancedPopulations.includes(OPTION_DICTIONARY_V3.pregnantAndPostpartum) &&
          requireRefrigerationBreastMilk &&
          (
            clinicalCriteria.includes(OPTION_DICTIONARY_V3.enternalOrParenteral)
            || additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.qRefrigerationBreastMilk)
          )
        )
      )
    ) {
      eligibleServices.push('Home Remediation Assistance: Equipment provision (refrigeration units) (Housing)');
    }

    if (
      enhancedConditionsSetOne &&
      (
        hasHousingSafetyConcerns ||
        hasUtilitiesIssues
      ) &&
      clinicalCriteria.includes(OPTION_DICTIONARY_V3.asthma) &&
      (
        additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.oAsthmaInpatient12mo)
        || additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.oAsthmaEDVisits12mo)
        || additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.oAsthmaUrgentCare12mo)
        || additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.oAsthmaSteroidRx12mo)
        || additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.oAsthmaInhalerRx12mo)
      )
    ) {
      eligibleServices.push('Asthma Remediation (Housing)');
    }

    if (
      enhancedConditionsSetOne &&
      housingIssuesSet &&
      (
        hasCareRecoveryNeed
        || hasHospitalRisk
      ) &&
      (
        additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.qPreSurgicalCare)
        || additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.qAcuteCareHospitalization)
        || additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.qRecuperationCare)
        || additionalClinicalConditions.includes(OPTION_DICTIONARY_V3.qMedicaidServiceRisk)
      )
    ) {
      eligibleServices.push('Medical Respite - Preprocedural Care (Housing)');
      eligibleServices.push('Medical Respite - Post Hospitalization Care (Housing)');
    }

    if (
      enhancedConditionsSetOne &&
      housingIssuesSetTwo
    ) {
      eligibleServices.push('Rent/Temporary Housing Rent Payment Assistance (Housing)');
    }

    if (
      enhancedConditionsSetOne &&
      housingIssuesSetTwo &&
      hasHousingSafetyConcerns &&
      (
        listOfHousingConcerns.includes('No heating or cooling when needed.')
        || listOfHousingConcerns.includes('No access to water, electricity, or other utilities.')
      ) &&
      hasUtilitiesIssues &&
      (
        listOfUtilitiesIssues.includes(OPTION_DICTIONARY_V3.oElectricityShutoff)
          || listOfUtilitiesIssues.includes(OPTION_DICTIONARY_V3.oNoRunningWater)
          || listOfUtilitiesIssues.includes(OPTION_DICTIONARY_V3.oNoElectricityAfford)
          || listOfUtilitiesIssues.includes(OPTION_DICTIONARY_V3.oNoHeatAfford)
          || listOfUtilitiesIssues.includes(OPTION_DICTIONARY_V3.oNoACAfford)
      )
    ) {
      eligibleServices.push(
        'Utility Payment Assistance (must be eligible for or receiving Rent / Temporary Rental Assistance to qualify) (Utilities)'
      );
      eligibleServices.push(
        'Utility Activation Payment (must be eligible for or receiving Rent / Temporary Rental Assistance to qualify) (Utilities)'
      );
      eligibleServices.push(
        'Utility Arrears Payment (must be eligible for or receiving Rent / Temporary Rental Assistance to qualify) (Utilities)'
      );
    }

    if (
      enhancedConditionsSetOne &&
      housingIssuesSet
    ) {
      eligibleServices.push('Pre-tenancy Services');
    }

    if (
      enhancedConditionsSetOne &&
      housingIssuesSet &&
      (
        hasHousingSafetyConcerns ||
        hasUtilitiesIssues
      )
    ) {
      eligibleServices.push('Community Transitional Supports (Housing)');
      eligibleServices.push('Tenancy Sustaining Services (Housing)');
      eligibleServices.push('Housing Transition and Navigation Services (Housing)');
    }

    if (
      enhancedConditionsSetOne &&
      (
        medicaidPlanType === OPTION_DICTIONARY_V3.oMMMC
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHARP
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHIVSNPS
        || medicaidPlanType === OPTION_DICTIONARY_V3.oOtherNotListedPlan
      ) &&
      listOfFoodAssistance.includes(OPTION_DICTIONARY_V3.oNutritionalCounseling)
    ) {
      eligibleServices.push('Nutritional Counseling and Education (Food)');
    }

    if (
      (
        medicaidPlanType === OPTION_DICTIONARY_V3.oMMMC
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHARP
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHIVSNPS
        || medicaidPlanType === OPTION_DICTIONARY_V3.oOtherNotListedPlan
      ) &&
      (
        (
          enhancedConditionsSetOne && clinicalCriteria.includes(OPTION_DICTIONARY_V3.chronicCondition)
        ) || enhancedPopulations.includes(OPTION_DICTIONARY_V3.pregnantAndPostpartum)
      ) &&
      (
        cannotPrepareMeals || caregiverCannotPrepareMeals
      ) &&
      !listOfServiceDuplication.includes(OPTION_DICTIONARY_V3.oMedicallyTailoredMeals)
    ) {
      eligibleServices.push('Medically Tailored Meals (MTM) (Food)');
    }

    if (
      enhancedConditionsSetOne &&
      (
        medicaidPlanType === OPTION_DICTIONARY_V3.oMMMC
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHARP
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHIVSNPS
        || medicaidPlanType === OPTION_DICTIONARY_V3.oOtherNotListedPlan
      ) &&
      listOfFoodAssistance.includes('Home-delivered meals') &&
      (
        cannotPrepareMeals || caregiverCannotPrepareMeals
      ) &&
      !listOfServiceDuplication.includes(OPTION_DICTIONARY_V3.oMedicallyTailoredMeals)
    ) {
      eligibleServices.push('Clinically Appropriate Meals (Food)');
    }

    if (
      enhancedConditionsSetOne &&
      (
        medicaidPlanType === OPTION_DICTIONARY_V3.oMMMC
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHARP
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHIVSNPS
        || medicaidPlanType === OPTION_DICTIONARY_V3.oOtherNotListedPlan
      ) &&
      (
        listOfFoodAssistance.includes(OPTION_DICTIONARY_V3.oFoodPantryAccess)
        || listOfFoodAssistance.includes(OPTION_DICTIONARY_V3.oGroceryShoppingHelp)
      ) &&
      caregiverCanPrepareMeals
    ) {
      eligibleServices.push('Food Prescriptions (Voucher / Boxes) (Food)');
    }

        if (
      (
        enhancedPopulations.includes(OPTION_DICTIONARY_V3.pregnantAndPostpartum) ||
        enhancedPopulations.includes(OPTION_DICTIONARY_V3.highRiskChildUnderEighteen)
      ) &&
      (
        medicaidPlanType === OPTION_DICTIONARY_V3.oMMMC
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHARP
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHIVSNPS
        || medicaidPlanType === OPTION_DICTIONARY_V3.oOtherNotListedPlan
      ) &&
      (
        listOfFoodAssistance.includes(OPTION_DICTIONARY_V3.oFoodPantryAccess)
        || listOfFoodAssistance.includes(OPTION_DICTIONARY_V3.oGroceryShoppingHelp)
      ) &&
      caregiverCanPrepareMeals &&
      !listOfServiceDuplication.includes(OPTION_DICTIONARY_V3.oMedicallyTailoredMeals)
    ) {
      eligibleServices.push('Fresh Produce and Nonperishable Groceries - Pantry Stocking (Food)');
    }

    if (
      enhancedConditionsSetOne &&
      (
        medicaidPlanType === OPTION_DICTIONARY_V3.oMMMC
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHARP
        || medicaidPlanType === OPTION_DICTIONARY_V3.oHIVSNPS
        || medicaidPlanType === OPTION_DICTIONARY_V3.oOtherNotListedPlan
      ) &&
      listOfFoodAssistance.includes(OPTION_DICTIONARY_V3.oCookingSupplies)
    ) {
      eligibleServices.push('Cooking Supplies (Food)');
    }

    if (
      enhancedConditionsSetOne &&
      hasTransportationAccess &&
      (
        transportationTroubleReasons.includes(OPTION_DICTIONARY_V3.oNoDriversLicense)
        || transportationTroubleReasons.includes(OPTION_DICTIONARY_V3.oNoWorkingVehicle)
        || transportationTroubleReasons.includes(OPTION_DICTIONARY_V3.oCannotTravelAlone)
      )
    ) {
      eligibleServices.push('Private Transportation (must also have at least one other HRSN need) (Transportation)');
      eligibleServices.push('Public Transportation (must also have at least one other HRSN need) (Transportation)');
    }

    return eligibleServices;
  } catch (error) {
    console.error('Error in getEligibleServiceUtilV4:', error);
    window.datadogLogs.logger.error('Error getting eligible services', {
      error: error,
      errorMessage: error.message,
      screening,
      identifiedNeeds,
    });
    return [];
  }
};

export default getEligibleServiceUtilV4;
